
import Vue from 'vue';
import Constants from '../../settings/ui';

export default Vue.extend({
  props: {
    radius: {
      type: Number,
      default: 0,
    },
    progress: {
      type: Number,
      default: 0,
    },
    stroke: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: Constants.colorPalette.darkGreen,
    },
    useOffset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const normalizedRadius = this.radius - this.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      normalizedRadius,
      circumference,
    };
  },
  computed: {
    strokeDashoffset(): number {
      return this.circumference - (this.progress / 100) * this.circumference;
    },
    baseStrokeDashoffset(): number {
      const offset = this.strokeDashoffset;
      return offset >= 150.796 && !this.useOffset ? offset : 0;
    },
  },
});
